import React, { useRef, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import "../../Pages/DeliveryChallan/DCprint.scss";
import { PDFExport } from "@progress/kendo-react-pdf";
import { MdCurrencyRupee } from "react-icons/md";
import { drawDOM, exportPDF } from "@progress/kendo-drawing";
import {
    createAPIEndpointServiceInvoice,
    EndpointServiceInvoice,
} from "../../Services/ServiceInvoice/ServiceInvoiceService";
import storage from "../../Services/Storage";
import { toast } from "react-toastify";
// import * as Fa from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const ServiceInvoice = ({
    DCpopup,
    setDCPopup,
    printData = { objHdr: {} },
    tag,
    invhid,
    getAllRecords,
    strType,
    rseName,
}) => {
    //printData
    // let printData;
    const pdfExportComponent = useRef(null);
    const printRef = useRef(null);
    const contentRef = useRef(null);
    const auth = storage.getLocal("user");
    const [isDownloading, setIsDownloading] = useState(false);

    const nav = useNavigate();
    // let DCpopup =true
    // const [DCpopup, setDCPopup] = useState(true);
    const getUniqueNo = () => {
        let date = new Date();
        let day = date.getDate();
        let month = date.getMonth() + 1;
        let year = date.getFullYear();
        let dateunique = date.valueOf();
        let uniqueNo = `ServiceInvoice-${day}-${month}-${year}-${dateunique}`;
        return uniqueNo;
    };

    useEffect(() => {
        
        const runAsync = async () => {
            if (tag === "R" ||tag==="U") {
                await exportToBase64(tag);
            }
        };

        runAsync();
    }, [printData]);

    // const blobToBase64 = (blob) =>
    //     new Promise((resolve, reject) => {
    //         const reader = new FileReader();
    //         reader.readAsDataURL(blob);
    //         reader.onloadend = () => {
    //             const base64 = reader.result.split(",")[1]; // Remove data prefix
    //             resolve(base64);
    //         };
    //         reader.onerror = reject;
    //     });

    // Send to emSigner via WebSocket
    // somewhere in your component or service

    const signWithEMSigner = (pdfBase64, filename) => {
        const bufferSize = 16300;
        const ws = new WebSocket("wss://127.0.0.1:2094");

        const chunks = [];
        for (let i = 0; i < pdfBase64.length; i += bufferSize) {
            chunks.push(pdfBase64.substring(i, i + bufferSize));
        }

        let chunkIndex = 0;
        let responseAccumulator = "";

        ws.onopen = () => {
            const params = `action=signpdf\ndatatosign=${pdfBase64}\nsignaction=3\noutputpath=\nsigntype=sign\nexpirycheck=true\ncoordinate=425,100,545,160\nissuername=\ncerttype=ALL\ncertclass=0\npageno=All\ncoSign=true`;
            ws.send(params);

            setTimeout(() => {
                sendNextChunk();
            }, 500);
        };

        ws.onerror = (err) => {
            toast.error("Please check you emSigner.", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            console.error("WebSocket Error:", err);
        };

        ws.onmessage = async (e) => {
            const msg = e.data;

            if (msg.includes("sendmore")) {
                sendNextChunk();
            } else {
                responseAccumulator += msg;

                if (msg.includes("completed")) {
                    const signedBase64 = responseAccumulator.replace("completed", "");
                    if (signedBase64.includes("Signature")) {
                        const signature = extractSignature(signedBase64);
                        if (signature) {
                            downloadPDF(signature, filename);
                            try {
                                const Payload = {
                                    compId: auth?.CompId,
                                    userId: auth?.UserId,
                                    invNo: invhid,
                                    base64String: signature,
                                };

                                const response = await createAPIEndpointServiceInvoice().post(
                                    `${EndpointServiceInvoice.WriteSignedCodeToPDF}`,
                                    Payload,
                                );
                                console.log(response);
                            } catch (err) {
                                console.log("Error ", err);
                            }
                        } else {
                            console.error("Signature not found or malformed.");
                        }
                    }
                    ws.close();
                }
            }
        };

        const sendNextChunk = () => {
            if (chunkIndex < chunks.length) {
                const chunk = chunks[chunkIndex];
                const isLastChunk = chunkIndex === chunks.length - 1;
                const finalChunk = isLastChunk ? chunk + "completed" : chunk;

                ws.send(finalChunk);
                // console.log(` Sent chunk ${chunkIndex + 1}/${chunks.length}`);
                chunkIndex++;
            }
        };
    };

    const extractSignature = (message) => {
        const match = message.match(
            /Signature=([A-Za-z0-9+/=\r\n]+?)\s(?:[A-Z]+=|CommonName=)/,
        );
        return match ? match[1].trim() : null;
    };
    // Convert Base64 to Blob and download
    const downloadPDF = (base64, filename) => {
        const blob = new Blob(
            [Uint8Array.from(atob(base64), (c) => c.charCodeAt(0))],
            {
                type: "application/pdf",
            },
        );
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        link.click();
        setDCPopup(false);
        getAllRecords();
    };
    const handleSignClick = async () => {
        const element = contentRef.current;
        if (!element) return;

        try {
            const group = await drawDOM(element, {
                paperSize: "A4",
                margin: 20,
                scale: 0.8,
            });

            const blob = await exportPDF(group);
            const base64 = blob.split(",")[1];
            signWithEMSigner(base64, "SignedInvoice.pdf");
        } catch (err) {
            console.error("Export or signing failed", err);
        }
    };

    const exportToBase64 = async (mailtype) => {
        if (contentRef.current) {
            setIsDownloading(true);
            const element = contentRef.current;

            const group = await drawDOM(element, {
                paperSize: "A4",
                margin: 40,
            });

            const dataUri = await exportPDF(group, { paperSize: "A4" });

            const base64String = dataUri.split(",")[1]; // remove the prefix if needed

            try {
                const Payload = {
                    compId: auth?.CompId,
                    userId: auth?.UserId,
                    invHdrId: invhid,
                    custName: rseName,
                    base64FileContent: base64String,
                };

                const response = await createAPIEndpointServiceInvoice().post(
                    `${mailtype=="U"?EndpointServiceInvoice.SendUrbanRSEMail:EndpointServiceInvoice.SendRSEMail}`,
                    Payload,
                );
                console.log(response);
            } catch (err) {
                console.log("Error ", err);
            } finally {
                setIsDownloading(false);
            }
        }
    };

    return (
        <>
            <Modal
                className="print-popup"
                show={DCpopup}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    <div id="printablediv">
                        <PDFExport
                            fileName={getUniqueNo()}
                            paperSize="A4"
                            forcePageBreak=".page-break"
                            ref={pdfExportComponent}
                        >
                            <div ref={contentRef}>
                                <>
                                    <div className="MobileViewInvoice">
                                        <div className="bgimg" id="dv1">
                                            <table
                                                cellSpacing="0"
                                                cellPadding="0"
                                                style={{ border: "none", width: "100%" }}
                                            >
                                                <div className="row">
                                                    <div className="col-7 pe-0">
                                                        <p
                                                            style={{
                                                                marginBottom: "2px",
                                                                fontSize: "10px",
                                                                textAlign: "right",
                                                                fontWeight: "bold",
                                                                textDecoration: "underline",
                                                            }}
                                                        >
                                                            {strType !== "R" && strType !== "U"
                                                                ? "Service Invoice"
                                                                : "License Fee"}
                                                        </p>
                                                        <div style={{ marginLeft: "6px" }}>
                                                            <tr style={{ float: "right", marginTop: "10px" }}>
                                                                <td>
                                                                    <b>
                                                                        <span id="Label2">Distributor PAN No</span>
                                                                    </b>
                                                                </td>
                                                                <td style={{ paddingLeft: "6px" }}>
                                  :{" "}
                                                                    <span>{printData?.objHdr?.lblDistPanNo}</span>
                                                                </td>
                                                            </tr>
                                                        </div>
                                                    </div>
                                                    <div className="col-5">
                                                        <tr>
                                                            <td>
                                                                <b>
                                                                    <span id="Label2">Invoice No</span>
                                                                </b>
                                                            </td>
                                                            <td style={{ paddingLeft: "6px" }}>
                                : <span>{printData?.objHdr?.lblInvNo}</span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <b>
                                                                    <span id="Label2">Invoice Date</span>
                                                                </b>
                                                            </td>
                                                            <td style={{ paddingLeft: "6px" }}>
                                : <span>{printData?.objHdr?.lblInvDate}</span>
                                                            </td>
                                                        </tr>
                                                        {strType !== "R" && strType !== "U" ? (
                                                            <tr>
                                                                <td>
                                                                    <b>
                                                                        <span id="Label2">Order No.</span>
                                                                    </b>
                                                                </td>
                                                                <td style={{ paddingLeft: "6px" }}>
                                  : <span>{printData?.objHdr?.lblSONo}</span>
                                                                </td>
                                                            </tr>
                                                        ) : null}
                                                        {strType !== "R"  && strType !== "U"  ? (
                                                            <tr>
                                                                <td>
                                                                    <b>
                                                                        <span id="Label2">Order Date</span>
                                                                    </b>
                                                                </td>
                                                                <td style={{ paddingLeft: "6px" }}>
                                  : <span>{printData?.objHdr?.lblSODate}</span>
                                                                </td>
                                                            </tr>
                                                        ) : null}
                                                        <tr>
                                                            <td>
                                                                <b>
                                                                    <span id="Label2">Distributor GSTN</span>
                                                                </b>
                                                            </td>
                                                            <td style={{ paddingLeft: "6px" }}>
                                : <span>{printData?.objHdr?.lblDistGST1}</span>
                                                            </td>
                                                        </tr>
                                                    </div>
                                                </div>
                                            </table>

                                            <table>
                                                <tr>
                                                    {printData?.objHdr?.lblIRNNo && (
                                                        <td>
                                                            <b>
                                                                <span id="Label2">IRN NO</span>
                                                            </b>{" "}
                              : <span>{printData?.objHdr?.lblIRNNo}</span>
                                                        </td>
                                                    )}
                                                </tr>
                                                <tr>
                                                    {printData?.objHdr?.lblACKNo && (
                                                        <td>
                                                            <b>
                                                                <span id="Label2">ACK#</span>
                                                            </b>{" "}
                              : <span>{printData?.objHdr?.lblACKNo}</span>
                                                            <b style={{ paddingLeft: "30px" }}>
                                                                <span id="Label2">Date</span>
                                                            </b>{" "}
                              : <span>{printData?.objHdr?.lblACKDate}</span>
                                                        </td>
                                                    )}
                                                </tr>
                                            </table>

                                            <table
                                                cellSpacing="0"
                                                cellPadding="0"
                                                style={{ border: "none" }}
                                            >
                                                <tr>
                                                    <td
                                                        style={{
                                                            width: "300px",
                                                            height: "15px",
                                                            verticalAlign: "top",
                                                        }}
                                                    >
                                                        <b>
                                                            <p
                                                                id="Label7"
                                                                style={{ fontSize: "9px", marginBottom: "2px" }}
                                                            >
                                Customer Address :
                                                            </p>
                                                        </b>
                                                        <p
                                                            id="lblrilcustcode"
                                                            style={{ marginBottom: "2px" }}
                                                        >
                                                            {printData?.objHdr?.lblCustCode}
                                                            <br />
                                                            <strong>{printData?.objHdr?.lblCustName}</strong>
                                                            <br />
                                                            {printData?.objHdr?.lblBillAdd1}
                                                            <br />
                                                            {printData?.objHdr?.lblBillAdd2}
                                                            <br />
                                                            {printData?.objHdr?.lblBillTown}
                                                            <br />
                                                            {printData?.objHdr?.lblBillState}
                                                            <br></br>
                                                            {printData?.objHdr?.lblCustGST && (
                                                                <>Customer {strType === "R" || strType === "U"  ? "GSTN:" : ""} </>
                                                            )}{" "}
                                                            {printData?.objHdr?.lblCustGST}
                                                        </p>
                                                    </td>
                                                    <td
                                                        style={{
                                                            width: "300px",
                                                            height: "15px",
                                                            verticalAlign: "top",
                                                        }}
                                                    ></td>
                                                    <td
                                                        style={{
                                                            width: "200px",
                                                            height: "15px",
                                                            verticalAlign: "middle",
                                                        }}
                                                    >
                                                        {/* {image1Src && (
                                                            <img
                                                                src={image1Src}
                                                                style={{ width: "50px", marginRight: "6px" }}
                                                                // onLoad={() => setImage1Loaded(true)}
                                                                onError={() => toast.error("Failed to load first image")}
                                                            />
                                                        )} */}
                                                        <img
                                                            src={printData?.objHdr?.imgQRCode}
                                                            style={{ width: "60px", marginRight: "6px" }}
                                                            crossOrigin="anonymous"
                                                        />
                                                    </td>
                                                </tr>
                                            </table>

                                            <div style={{ minHeight: "290px" }}>
                                                <div
                                                    style={{
                                                        minHeight: "280px",
                                                        display: "inline-block",
                                                        width: "100%",
                                                        position: "relative",
                                                        border: "1px solid #000",
                                                        padding: "1px",
                                                    }}
                                                >
                                                    <div id="tbl01">
                                                        <table
                                                            id="tblDetl"
                                                            border="0"
                                                            cellSpacing="0"
                                                            cellPadding="0"
                                                            width="100%"
                                                        >
                                                            <tbody>
                                                                <tr
                                                                    className="headerClass"
                                                                    style={{ borderBottom: "1px solid #000" }}
                                                                >
                                                                    <td align="left" style={{ width: "20px" }}>
                                                                        <span style={{ textAlign: "left" }}>
                                      Sr<br></br>No
                                                                        </span>
                                                                    </td>
                                                                    <td align="left" style={{ width: "100px" }}>
                                                                        <span style={{ textAlign: "left" }}>
                                                                            {strType !== "R"  && strType !== "U" 
                                                                                ? "Product Pack Description"
                                                                                : "Service"}
                                                                        </span>
                                                                    </td>
                                                                    <td align="right">
                                                                        <span style={{ textAlign: "right" }}>
                                      HSN/SAC
                                                                        </span>
                                                                    </td>
                                                                    <td align="right">
                                                                        <span style={{ textAlign: "right" }}>
                                      Value Rs. Excluding GST
                                                                        </span>
                                                                    </td>
                                                                    {Number(
                                                                        String(
                                                                            printData?.objProdDetl?.[0]
                                                                                ?.IGST_AMOUNT || "",
                                                                        ).replace(/,/g, ""),
                                                                    ) > 0 ? (
                                                                            <td align="right">
                                                                                <span style={{ textAlign: "right" }}>
                                        IGST&nbsp;Rs.<br></br>Rate%
                                                                                </span>
                                                                            </td>
                                                                        ) : (
                                                                            <>
                                                                                <td align="right">
                                                                                    <span style={{ textAlign: "right" }}>
                                          CGST&nbsp;Rs.<br></br>Rate%
                                                                                    </span>
                                                                                </td>
                                                                                <td align="right">
                                                                                    <span style={{ textAlign: "right" }}>
                                          SGST&nbsp;Rs.<br></br>Rate%{" "}
                                                                                    </span>
                                                                                </td>
                                                                            </>
                                                                        )}
                                                                </tr>

                                                                {printData?.objProdDetl?.map((val) => {
                                                                    return (
                                                                        <tr
                                                                            key={val?.SrNo}
                                                                            style={{ height: "25px" }}
                                                                        >
                                                                            <>
                                                                                <td>
                                                                                    <span
                                                                                        style={{
                                                                                            width: "20px",
                                                                                            textAlign: "left",
                                                                                        }}
                                                                                    >
                                                                                        {val?.SrNo}
                                                                                    </span>
                                                                                </td>
                                                                                <td style={{ wordBreak: "break-all" }}>
                                                                                    <span
                                                                                        style={{
                                                                                            width: "100px",
                                                                                            textAlign: "left",
                                                                                        }}
                                                                                    >
                                                                                        {val?.Description}
                                                                                    </span>
                                                                                </td>
                                                                                <td align="right">
                                                                                    <span
                                                                                        style={{
                                                                                            width: "50px",
                                                                                            textAlign: "right",
                                                                                        }}
                                                                                    >
                                                                                        {val?.HSN_SAC}
                                                                                    </span>
                                                                                </td>
                                                                                <td align="right">
                                                                                    <span
                                                                                        style={{
                                                                                            width: "42px",
                                                                                            textAlign: "right",
                                                                                        }}
                                                                                    >
                                                                                        {val?.Value_Rs_Excluding_GST}
                                                                                    </span>
                                                                                </td>
                                                                                {Number(
                                                                                    String(
                                                                                        printData?.objProdDetl?.[0]
                                                                                            ?.IGST_AMOUNT || "",
                                                                                    ).replace(/,/g, ""),
                                                                                ) > 0 ? (
                                                                                        <td align="right">
                                                                                            <span
                                                                                                style={{
                                                                                                    width: "50px",
                                                                                                    textAlign: "right",
                                                                                                }}
                                                                                            >
                                                                                                {val?.IGST_AMOUNT}
                                                                                                <p className="mb-0">
                                                                                                    {val?.IGST_RATE}
                                                                                                </p>
                                                                                            </span>
                                                                                        </td>
                                                                                    ) : (
                                                                                        <>
                                                                                            <td align="right">
                                                                                                <span
                                                                                                    style={{
                                                                                                        width: "50px",
                                                                                                        textAlign: "right",
                                                                                                    }}
                                                                                                >
                                                                                                    {val?.CGST_AMOUNT}
                                                                                                    <p className="mb-0">
                                                                                                        {val?.CGST_RATE}
                                                                                                    </p>
                                                                                                </span>
                                                                                            </td>
                                                                                            <td align="right">
                                                                                                <span
                                                                                                    style={{
                                                                                                        width: "50px",
                                                                                                        textAlign: "right",
                                                                                                    }}
                                                                                                >
                                                                                                    {val?.SGST_UTGST_AMOUNT}
                                                                                                    <p className="mb-0">
                                                                                                        {val?.SGST_UTGST_RATE}
                                                                                                    </p>
                                                                                                </span>
                                                                                            </td>
                                                                                        </>
                                                                                    )}
                                                                            </>
                                                                        </tr>
                                                                    );
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>

                                            <div style={{ marginTop: "-10px" }}>
                                                <table border="0" cellSpacing="0" cellPadding="4">
                                                    <tbody>
                                                        <tr>
                                                            <td
                                                                align="left"
                                                                valign="top"
                                                                style={{ width: "400px" }}
                                                            >
                                                                <b>
                                                                    {/* eslint-disable-next-line */}
                                  <span id="Label9">
                                    Receiver&apos;s Signature Date &amp; Stamp
                                                                    </span>
                                                                </b>
                                                            </td>
                                                            <td align="right" style={{ width: "198px" }}>
                                                                <b>
                                                                    <span id="Label10">Total</span>
                                                                </b>
                                                            </td>
                                                            <td align="right" style={{ width: "60px" }}>
                                                                <span id="lblSumAmt">
                                                                    {printData?.objDetl?.lblSumAmt}
                                                                </span>
                                                            </td>
                                                            {Number(
                                                                String(
                                                                    printData?.objProdDetl?.[0]?.IGST_AMOUNT ||
                                    "",
                                                                ).replace(/,/g, ""),
                                                            ) > 0 ? (
                                                                    <td align="right" style={{ width: "60px" }}>
                                                                        <span id="lblSumSGST">
                                                                            {printData?.objDetl?.lblSumIGST}
                                                                        </span>
                                                                    </td>
                                                                ) : (
                                                                    <>
                                                                        <td align="right" style={{ width: "60px" }}>
                                                                            <span id="lblSumSGST">
                                                                                {printData?.objDetl?.lblSumCGST}
                                                                            </span>
                                                                        </td>
                                                                        <td align="right" style={{ width: "60px" }}>
                                                                            <span id="lblSumSGST">
                                                                                {printData?.objDetl?.lblSumSGST}
                                                                            </span>
                                                                        </td>
                                                                    </>
                                                                )}
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        <div style={{ padding: "5px" }}>
                                            <table
                                                border="0"
                                                cellSpacing="0"
                                                cellPadding="0"
                                                style={{ lineHeight: "16px" }}
                                            >
                                                <tbody>
                                                    <tr>
                                                        <td style={{ width: "421px" }}></td>
                                                        <td style={{ width: "190px", textAlign: "right" }}>
                                                            <b>
                                                                <span id="Label11">Gross Amount</span>
                                                            </b>
                                                        </td>
                                                        <td align="right" style={{ width: "56px" }}>
                                                            <span id="lblGrossAmt">
                                                                <MdCurrencyRupee />
                                                                {printData?.objDetl?.lblGrossAmt}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td valign="top">
                                                            <b>
                                                                <span id="Label14">
                                  Amount Payable (in Words)
                                                                </span>
                                                            </b>
                                                        </td>
                                                        <td align="right">
                                                            <b>
                                                                <span id="Label15">GST</span>
                                                            </b>
                                                        </td>
                                                        <td align="right">
                                                            <span id="lblTotalVat">
                                                                <MdCurrencyRupee />
                                                                {printData?.objDetl?.lblTotalVat}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td rowSpan="4" valign="top">
                                                            <b>
                                                                <span id="Label16" className="lblRs">
                                  Rupees : &nbsp;
                                                                </span>
                                                            </b>
                                                            <span id="lblAmtInWord" className="amtWord">
                                                                {printData?.objDetl?.lblAmtInWord}
                                                            </span>
                                                            <br></br>
                                                            <br></br>
                                                            <div
                                                                style={{
                                                                    border: "1px solid #333",
                                                                    padding: "2px",
                                                                    display: "inline-block",
                                                                    fontWeight: "bold",
                                                                    fontSize: "9px",
                                                                }}
                                                            >
                                                                <span id="Label58">
                                  Customer Service Toll Free
                                  No:1800222100/18002098100
                                                                </span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: "right" }}>
                                                            <b>
                                                                <span id="Label55">Grand Total</span>
                                                            </b>
                                                        </td>
                                                        <td align="right">
                                                            <span id="lblTotal">
                                                                <MdCurrencyRupee />
                                                                {printData?.objDetl?.lblTotal}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </>
                            </div>
                        </PDFExport>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="btn btn-cancel-red me-2"
                        onClick={() => setDCPopup(false)}
                        disabled={isDownloading}
                    >
            Close
                    </button>
                    {tag == "N" || tag == "R" ||strType==="U" ? (
                        <button
                            className="btn btn-primary me-2"
                            ref={printRef}
                            onClick={() => {
                                // debugger
                                if (pdfExportComponent.current) {
                                    pdfExportComponent.current.save();
                                    setDCPopup(false);
                                }
                                if(strType==="U"){
                                    nav("/salesmanagement/urbanserviceinvoice");
                                }
                                else if (tag !=="U") {
                                    nav("/salesmanagement/serviceinvoice");
                                }
                            }}
                        >
              Download
                        </button>
                    ) : (
                        <button
                            ref={printRef}
                            className="btn btn-primary"
                            onClick={async () => {
                                handleSignClick();
                            }}
                        >
              Sign & Download
                        </button>
                    )}
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ServiceInvoice;
